export default "__VITE_ASSET__a61631dd__"